import Immutable from 'immutable';
import * as types from './AdminPromotionalItems.types';

const initialState = {
    type: null,
    promotionalItems: [],
    fetching: false,
    saving: false,
    idModal: null,
    pagination: {
        totalElements: 0,
        activePage: 1,
        totalPages: 0,
        elementsPerPage: 15,
    },
    promotionalItem: {
        allow_utp: 0,
        allow_uth: 0,
        allow_manager: 0,
        allow_personal: 0,
        allow_coupa: 0,
        is_bundles: 0,
        pieces_per_bundle: '',
        pricing: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        pricing_enabled: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
    },
    imageFile: null,
    departments: [],
    fetchingDepartments: false,
    isDeleting: false,
    sort: {
        column: 'name',
        type: 'asc',
    },
    search: '',
    searchType: 'name',
    isUploading: false,
    uploadFile: null,
}

export default function (state = initialState, action) {
    state = Immutable.fromJS(state);
    switch (action.type) {
        case types.FETCH_PROMOTIONAL_ITEMS:
            return state.setIn(['fetching'], true).toJS();

        case types.FETCH_PROMOTIONAL_ITEMS_SUCCESS:
            return state.setIn(['fetching'], false)
                .setIn(['promotionalItems'], action.payload.elements)
                .setIn(['pagination', 'totalElements'], action.payload.totalElements)
                .setIn(['pagination', 'activePage'], action.payload.activePage)
                .setIn(['pagination', 'totalPages'], action.payload.totalPages)
                .setIn(['pagination', 'elementsPerPage'], action.payload.elementsPerPage)
                .toJS();

        case types.FETCH_PROMOTIONAL_ITEMS_ERROR:
            return state.setIn(['fetching'], false).toJS();

        case types.FETCH_DEPARTMENTS:
            return state.setIn(['fetchingDepartments'], true).toJS();

        case types.FETCH_DEPARTMENTS_SUCCESS:
            return state.setIn(['fetchingDepartments'], false)
                .setIn(['departments'], action.payload)
                .toJS();

        case types.FETCH_DEPARTMENTS_ERROR:
            return state.setIn(['fetchingDepartments'], false).toJS();

        case types.SAVE_PROMOTIONAL_ITEM:
            return state.setIn(['saving'], true).toJS();

        case types.SAVE_PROMOTIONAL_ITEM_SUCCESS:
            return state.setIn(['saving'], false)
                .setIn(['idModal'], null)
                .toJS();

        case types.SAVE_PROMOTIONAL_ITEM_ERROR:
            return state.setIn(['saving'], false).toJS();

        case types.DELETE_PROMOTIONAL_ITEM:
            return state.setIn(['isDeleting'], true).toJS();

        case types.DELETE_PROMOTIONAL_ITEM_SUCCESS:
            return state.setIn(['isDeleting'], false)
                .setIn(['idModal'], null)
                .toJS();

        case types.DELETE_PROMOTIONAL_ITEM_ERROR:
            return state.setIn(['isDeleting'], false).toJS();

        case types.UPLOAD_FILE:
            return state.setIn(['isUploading'], true).toJS();

        case types.UPLOAD_FILE_SUCCESS:
            return state.setIn(['isUploading'], false)
                .setIn(['uploadFile'], null)
                .toJS();

        case types.UPLOAD_FILE_ERROR:
            return state.setIn(['isUploading'], false).toJS();

        case types.SET_ID_MODAL:
            return state.setIn(['idModal'], action.payload).toJS();

        case types.SET_ACTIVE_PAGE:
            return state.setIn(['pagination', 'activePage'], action.payload).toJS();

        case types.SET_PROMOTIONAL_ITEM_FIELD:
            return state.setIn(['promotionalItem', action.payload.field], action.payload.value).toJS();

        case types.SET_PROMOTIONAL_ITEM:
            return state.setIn(['promotionalItem'], action.payload).toJS();

        case types.SET_IMAGE_FILE:
            return state.setIn(['imageFile'], action.payload).toJS();

        case types.SET_UPLOAD_FILE:
            return state.setIn(['uploadFile'], action.payload).toJS();

        case types.RESET_PROMOTIONAL_ITEM:
            return state.setIn(['promotionalItem'], {
                allow_utp: 0,
                allow_uth: 0,
                allow_manager: 0,
                allow_personal: 0,
                allow_coupa: 0,
                is_bundles: 0,
                pieces_per_bundle: '',
                pricing: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                pricing_enabled: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
            }).toJS();

        case types.SET_SORT:
            return state.setIn(['sort', 'type'], action.payload.type)
                .setIn(['sort', 'column'], action.payload.column)
                .toJS();

        case types.SET_SEARCH:
            return state.setIn(['search'], action.payload).toJS();

        case types.SET_SEARCH_TYPE:
            return state.setIn(['searchType'], action.payload).toJS();

        case types.SET_PRICE:
            return state.updateIn(['promotionalItem', 'pricing'], (pricing) => {
                let newPricing = pricing.toJS();
                newPricing[action.payload.index] = action.payload.price;
                return newPricing;
            }).toJS();

        case types.SET_ENABLED:
            return state.updateIn(['promotionalItem', 'pricing_enabled'], (pricingEnabled) => {
                let newPricing = pricingEnabled.toJS();
                newPricing[action.payload.index] = action.payload.enabled;
                return newPricing;
            }).toJS();

        case types.RESET_STATE:
            return initialState;

        default:
            return state.toJS();
    }
}